import {
  CinematicSceneType,
  CinematicTypeEnum,
  Direction,
} from "game-engine/types";

import { ACTION } from "game-engine/utils";
import CHARACTER_CONFIGS from "game-files/characters/CHARACTER_CONFIGS";
import { CinematicId } from "game-files/common/ids";
import DevScene03 from "game-files/scenes/__to-delete__dev-scenes/DevScene03";

const TestCinematicScene01: CinematicSceneType = {
  id: CinematicId.TestCinematicScene01,
  type: CinematicTypeEnum.scene,

  uniqueSceneId: "DevScene03", // necessary for placing items in scene + for scenes outside scenes layout
  scene: DevScene03,
  audio: false, // turn off scene audio (that is defined in the scene config)

  characters: [
    {
      config: CHARACTER_CONFIGS.Felix,
      position: { x: 233, y: 134 },
      facing: Direction.left,
    },
    {
      config: CHARACTER_CONFIGS.TestCharacter,
      position: undefined, // defined in ACTION.walkIntoScene
      facing: Direction.right,
    },
  ],

  fadeIn: { durationSec: 2 }, // or boolean
  fadeOut: true,

  actions: [
    ACTION.walkIntoScene({
      characterId: CHARACTER_CONFIGS.TestCharacter.id,
      fromDirection: Direction.left,
      toPosition: { x: 118, y: 140 },
    }),

    ACTION.talk({
      characterId: CHARACTER_CONFIGS.TestCharacter.id,
      dialog: {
        en: `Well, this is a cinematic scene preview.`,
        cz: `No, tohle je ukázka cinematic scény.`,
      },
    }),

    ACTION.talk({
      dialog: {
        en: `Yes, now we can talk like in a movie.`,
        cz: `Ano, teď můžeme kecat jako ve filmu.`,
      },
    }),

    ACTION.talk({
      characterId: CHARACTER_CONFIGS.TestCharacter.id,
      dialog: {
        en: `Welp, I'm gonna head out.`,
        cz: `No, já to tu balím.`,
      },
    }),

    ACTION.walkOutOfScene({
      characterId: CHARACTER_CONFIGS.TestCharacter.id,
      toDirection: Direction.left,
      fromPosition: { x: 118, y: 140 },
      unskippableWalkOut: true,
    }),
  ],
};

export default TestCinematicScene01;
